module.exports = __webpack_public_path__ + "static/img/noDataIcon.776c2c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/noDataIcon.png
// module id = yn8g
// module chunks = 2